/** Motion tokens for JS-driven animation (CSS uses the same values). Seconds. */
export const motion = {
  fast: 0.15,
  base: 0.2,
  ease: [0.2, 0.8, 0.2, 1] as const,
} as const;

export type Tone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

/** Soft background + strong foreground per tone (badges, alerts, icons). */
export const toneClasses: Readonly<Record<Tone, string>> = {
  neutral: 'bg-surface-muted text-ink-muted',
  primary: 'bg-primary-soft text-primary',
  success: 'bg-success-soft text-success',
  warning: 'bg-warning-soft text-warning',
  danger: 'bg-danger-soft text-danger',
  info: 'bg-info-soft text-info',
};
